export class Equipment {
  id: Number;
  equipmentType: string;
  make: string;
  model: string;
  machineId: string;
  safetyManager: string;
  serviceManager: string;
  users: Users[];
}

export class Users {
  id: Number;
  firstName: string;
  lastName: string;
  email: string; 
  roleId: number;
}


export class EquipmentDetail{
  equipment: Equipment;
  checkList: CheckList[];

}

export class CheckList {
  id: Number;
  title: string;
  serviceName: string;
  icon: string; 
  serviceId: number;
  equipmentTypeId: number;
  checkListItems: CheckListItems[];
}

export class CheckListItems {
  id: Number; 
  title: string; 
  checkListId: number;
  minTime: number;
}





// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/entities/Equipment.ts